/* eslint-disable no-multi-str */
import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';


class TextEditor extends Component {
  render() {
    return <div className={this.props.wrapper}>
      <Editor
        apiKey="1ap291yd6yzb6zy754vca2x3usoesps31k22essfuyl0i5i3"
        //initialValue={this.props.value} 
        init={{
          content_style: "@import url('https://fonts.googleapis.com/css2?family=Maitree:wght@300;400;500;600;700&display=swap'); body{font-family: Maitree, serif;}",
          height: 350,

          selector: 'textarea',     //Spell Check Part
          browser_spellcheck: true, //Spell Check Part
          contextmenu: false,       //Spell Check Part

          menubar: 'edit format',
          menu: {
            edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
            format: { title: 'Format', items: 'bold italic underline strikethrough | forecolor backcolor | removeformat' },
          },
          plugins: [
            'lists',
            'table',
            'autolink',
            'link',
            'charmap',
            'anchor',
            'insertdatetime',
            'wordcount',
            'powerpaste'
          ],
          toolbar:
            'undo redo | bold italic backcolor | \
            alignleft aligncenter alignright | \
            bullist numlist outdent indent | table',
          powerpaste_word_import: 'clean',
          powerpaste_html_import: 'clean',
          paste_data_images: false,
          powerpaste_allow_local_images: false,     
          smart_paste: false,
          table_advtab: true,
          table_cell_advtab: true,
          table_row_advtab: true,
          paste_preprocess: (plugin, args) => {
            // Remove <img> tags with data URI src
            args.content = args.content.replace(
              /<img\b[^>]*src=["']?data:[^>]*>/gi,
              ''
            );
            // Remove <img> tags with empty src (src="" or src='')
            args.content = args.content.replace(
              /<img\b[^>]*src=["']{2}[^>]*>/gi,
              ''
            );
            // Remove raw base64 data URIs leftover in text
            args.content = args.content.replace(
              /data:image\/[a-zA-Z0-9.+-]+;base64,[A-Za-z0-9+/=\s]+/gi,
              ''
            );
          },
          paste_postprocess: (plugin, args) => {
            args.node.innerHTML = args.node.innerHTML
              // Remove <img> with data URI src
              .replace(/<img\b[^>]*src=["']?data:[^>]*>/gi, '')
              // Remove <img> with empty src (src="" or src='')
              .replace(/<img\b[^>]*src=["']{2}[^>]*>/gi, '')
              // Remove escaped <img> tags with data URI src appearing as plain text
              .replace(/&lt;img\b[^&]*src=["']?data:[^&]*&gt;/gi, '')
              // Remove escaped <img> tags with empty src only (src="" or src='')
              .replace(/&lt;img\b[^&]*src=["']{2}[^&]*&gt;/gi, '')
              // Remove leftover empty paragraphs or paragraphs with only whitespace
              .replace(/<p[^>]*>\s*<\/p>/gi, '')
              .replace(/<p[^>]*>(\s|&nbsp;)*<\/p>/gi, '');
          },     
        }}
        onBlur={this.props.onBlur}
        className="z-30"
        id={this.props.id}
        onEditorChange={this.props.onChange}
        value={this.props.value}
        readonly={this.props.readonly}
        disabled={this.props.disabled}
      />
    </div>
  }
}

export default TextEditor;
